import React from 'react';
import Helmet from 'react-helmet';
import { translate } from '../../assets/js/functions';

const LayoutDefault =({pageMeta, children}) =>{


    return(
        <>
        <Helmet>
            <html className="no-js" lang="ca"/>
            <meta charset="UTF-8"/>
            <meta name="viewport" content="width=device-width, initial-scale=1"/>
            {(pageMeta.desc)?<meta name="description" content={pageMeta.desc} />:''}
            <meta http-equiv="X-UA-Compatible" content="IE=edge"/>
            <title>{(pageMeta.title)?pageMeta.title+' | ':''}{translate('Cuidar')} | {translate('COIB')}</title>

            <link rel="apple-touch-icon" sizes="57x57" href="/favicons/apple-touch-icon-57x57.png"/>
            <link rel="apple-touch-icon" sizes="60x60" href="/favicons/apple-touch-icon-60x60.png"/>
            <link rel="apple-touch-icon" sizes="72x72" href="/favicons/apple-touch-icon-72x72.png"/>
            <link rel="apple-touch-icon" sizes="76x76" href="/favicons/apple-touch-icon-76x76.png"/>
            <link rel="apple-touch-icon" sizes="114x114" href="/favicons/apple-touch-icon-114x114.png"/>
            <link rel="apple-touch-icon" sizes="120x120" href="/favicons/apple-touch-icon-120x120.png"/>
            <link rel="apple-touch-icon" sizes="144x144" href="/favicons/apple-touch-icon-144x144.png"/>
            <link rel="apple-touch-icon" sizes="152x152" href="/favicons/apple-touch-icon-152x152.png"/>
            <link rel="apple-touch-icon" sizes="180x180" href="/favicons/apple-touch-icon-180x180.png"/>
            <link rel="icon" type="image/png" href="/favicons/favicon-32x32.png" sizes="32x32"/>
            <link rel="icon" type="image/png" href="/favicons/favicon-194x194.png" sizes="194x194"/>
            <link rel="icon" type="image/png" href="/favicons/favicon-96x96.png" sizes="96x96"/>
            <link rel="icon" type="image/png" href="/favicons/android-chrome-192x192.png" sizes="192x192"/>
            <link rel="icon" type="image/png" href="/favicons/favicon-16x16.png" sizes="16x16"/>
            <link rel="manifest" href="/favicons/manifest.json"/>
            <link rel="mask-icon" href="/favicons/safari-pinned-tab.svg" color="#0f7591"/>
            <meta name="msapplication-TileColor" content="#da532c"/>
            <meta name="msapplication-TileImage" content="favicon/mstile-144x144.png"/>
            <meta name="theme-color" content="#ffffff"/>

            <body id="top" className={'has-background-white ' + pageMeta.customCssClass ? pageMeta.customCssClass : ''} />
        </Helmet>
        {children}
        </>
    )
}

export default LayoutDefault;